import React from "react";

export const Divider = () => {
    return (
        <div className="h-[1px] bg-slate-200 w-full" />
    )
}